import React, { useState } from "react";
import "../css/AdmissionEnquiryForm.css";

const AdmissionEnquiryForm = () => {
  const [formData, setFormData] = useState({
    studentName: "",
    dob: "",
    gender: "",
    grade: "",
    fatherName: "",
    motherName: "",
    phone: "",
    email: "",
    address: "",
    city: "",
    country: "Nepal",
    message: "",
    agree: false,
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.agree) {
      alert("Please accept the Terms & Conditions.");
      return;
    }

    setLoading(true);

    console.log(formData);

    setTimeout(() => {
      alert("Admission Enquiry Submitted Successfully!");

      setFormData({
        studentName: "",
        dob: "",
        gender: "",
        grade: "",
        fatherName: "",
        motherName: "",
        phone: "",
        email: "",
        address: "",
        city: "",
        country: "Nepal",
        message: "",
        agree: false,
      });

      setLoading(false);
    }, 1000);
  };

  return (
    <>
      {}

      <section
        className="admission-hero"
        style={{
          backgroundImage:
            "linear-gradient(rgba(16,44,78,.75),rgba(16,44,78,.75)),url('/images/ae.jpeg')",
        }}
      >
        <div className="container">
          <div className="hero-content">
            <span className="hero-tag">SAHARA PUBLIC SCHOOL</span>

            <h1>Admission Enquiry Form</h1>

            <p>
              Thank you for your interest in Sahara Public School. Fill in the
              enquiry form below and our admission counsellor will contact you
              shortly.
            </p>
          </div>
        </div>
      </section>

      {}

      <section className="admission-form-section">
        <div className="container">
          <div className="admission-wrapper">
            {}

            <div className="admission-left">
              <h2>Student Information</h2>

              <form onSubmit={handleSubmit}>
                <div className="form-grid">
                  <div className="form-group">
                    <label>Student Full Name *</label>

                    <input
                      type="text"
                      name="studentName"
                      value={formData.studentName}
                      onChange={handleChange}
                      placeholder="Enter Student Name"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Date of Birth *</label>

                    <input
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Gender *</label>

                    <select
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Gender</option>
                      <option>Male</option>
                      <option>Female</option>
                      <option>Other</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Applying Grade *</label>

                    <select
                      name="grade"
                      value={formData.grade}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Grade</option>
                      <option>Nursery</option>
                      <option>LKG</option>
                      <option>UKG</option>
                      <option>Class 1</option>
                      <option>Class 2</option>
                      <option>Class 3</option>
                      <option>Class 4</option>
                      <option>Class 5</option>
                      <option>Class 6</option>
                      <option>Class 7</option>
                      <option>Class 8</option>
                      <option>Class 9</option>
                      <option>Class 10</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Father's Name *</label>

                    <input
                      type="text"
                      name="fatherName"
                      value={formData.fatherName}
                      onChange={handleChange}
                      placeholder="Father's Name"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Mother's Name *</label>

                    <input
                      type="text"
                      name="motherName"
                      value={formData.motherName}
                      onChange={handleChange}
                      placeholder="Mother's Name"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Parent Mobile Number *</label>

                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+977 98XXXXXXXX"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Email Address *</label>

                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="example@gmail.com"
                      required
                    />
                  </div>

                  <div className="form-group full-width">
                    <label>Residential Address *</label>

                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      placeholder="Enter Complete Address"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>City *</label>

                    <input
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      placeholder="Enter City"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Country *</label>

                    <select
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                    >
                      <option>Nepal</option>
                      <option>India</option>
                      <option>Bhutan</option>
                      <option>Bangladesh</option>
                      <option>Other</option>
                    </select>
                  </div>

                  <div className="form-group full-width">
                    <label>Message / Remarks</label>

                    <textarea
                      rows="5"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Write your enquiry..."
                    ></textarea>
                  </div>

                  <div className="checkbox-group full-width">
                    <input
                      type="checkbox"
                      name="agree"
                      checked={formData.agree}
                      onChange={handleChange}
                    />

                    <span>
                      I agree that Sahara Public School may contact me regarding
                      admission updates and school information.
                    </span>
                  </div>

                 <div className="full-width">
  <button
    type="submit"
    className="btn btn-primary btn-full"
    disabled={loading}
  >
    {loading ? "Submitting..." : "Submit Enquiry"}
  </button>
</div>
                </div>
              </form>
            </div>

            {}

            <div className="admission-right">
              <div className="info-card">
                <h3>Admission Help Desk</h3>

                <p>
                  <strong>Phone:</strong> +977-9847040404
                </p>

                <p>
                  <strong>Email:</strong> info@saharapublicschool.edu.np
                </p>

                <p>
                  <strong>Office Hours:</strong>
                </p>

                <p>Sunday – Friday</p>

                <p>09:00 AM – 04:00 PM</p>
              </div>

              <div className="info-card">
                <h3>Required Documents</h3>

                <ul>
                  <li>Birth Certificate</li>

                  <li>Previous School Report Card</li>

                  <li>Transfer Certificate</li>

                  <li>2 Passport Size Photographs</li>

                  <li>Parent Citizenship Copy</li>
                </ul>
              </div>

              <div className="info-card">
                <h3>Why Sahara Public School?</h3>

                <ul>
                  <li>✔ SEE Curriculum</li>

                  <li>✔ Smart Classrooms</li>

                  <li>✔ Modern Science & Computer Labs</li>

                  <li>✔ Experienced Teachers</li>

                  <li>✔ Sports & Extra-Curricular Activities</li>

                  <li>✔ Safe & Secure Campus</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default AdmissionEnquiryForm;
